// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m915vq{overflow-y:hidden}
._1bto1l2s{text-overflow:ellipsis}
._1e0c1o8l{display:inline-block}
._1reo15vq{overflow-x:hidden}
._kqswh2mm{position:relative}
._o5721q9c{white-space:nowrap}
._s7n4yfq0{vertical-align:bottom}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-ui/dist/esm/truncateText-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,sBAAsB;AACjC,WAAW,oBAAoB;AAC/B,WAAW,iBAAiB;AAC5B,WAAW,iBAAiB;AAC5B,WAAW,kBAAkB;AAC7B,WAAW,qBAAqB","sourcesContent":["._18m915vq{overflow-y:hidden}\n._1bto1l2s{text-overflow:ellipsis}\n._1e0c1o8l{display:inline-block}\n._1reo15vq{overflow-x:hidden}\n._kqswh2mm{position:relative}\n._o5721q9c{white-space:nowrap}\n._s7n4yfq0{vertical-align:bottom}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
